import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./ErrorMessage.module.css";
export const ErrorMessage = _ref => {
  let {
    message
  } = _ref;
  return _jsx("span", {
    className: styles.message,
    children: message
  });
};